// extracted by mini-css-extract-plugin
export default {"subMenu":"styles_subMenu__jXzCv","actions":"styles_actions__A3MtS","spacer":"styles_spacer__YYi57"};